export enum OrderStatusBadgeEnum {
  IN_PROGRESS = 'in progress',
  COMPLETE = 'complete',
  QUOTED = 'quoted',
}
